export const GETNOTIFICATION = "GETNOTIFICATION";
export const RESETNOTIFICATION = "RESETNOTIFICATION";